import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-workflow',
  templateUrl: './app-workflow.component.html',
  styleUrls: ['./app-workflow.component.scss']
})
export class AppWorkflowComponent  {
  

  isSidebarOpen = false;
  isAdmin = true; // set to false to hide admin-only sections
  isNavbarCollapsed = true;
  isTopBarShow: boolean = true;



  constructor(private router: Router) {
    // close mobile offcanvas when route fragment navigation completes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.closeSidebar();
      }
    });
  }

 

  public currentYear: string = new Date().getFullYear().toString();

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  // Optional: close offcanvas when clicking ESC
  @HostListener('document:keydown.escape', ['$event'])
  onEsc(event: KeyboardEvent) {
    this.closeSidebar();
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }
}
